import React from "react";
import styles from "./Hero.module.css";
import bgImage from "./../../../Images/string-wave.png"; // replace with your image

export default function Hero() {
  return (
    <div className={styles.container}>
      {/* Hero Section with background image behind */}
      <div className={styles.heroWrapper}>
        <img src={bgImage} alt="background" className={styles.bgImage} />

        <div className={styles.hero}>
          <h2 className={styles.title}>Smart Resume Screening</h2>
          <h2 className={styles.subtitle}>
            with <span className={styles.brand}>ToxBox AI</span>
          </h2>
          <p className={styles.description}>
            Instantly screen, rank, and shortlist the best candidates with
            AI-powered resume analysis. Hire smarter, faster, and with
            confidence.
          </p>
          <button className={styles.cta}>Start Smart Resume Screening</button>
        </div>
      </div>

      {/* Resume Card */}
      <div className={styles.cardWrapper}>
        <div className={styles.card}>
          <h3>ToxBox AI</h3>
          <p className={styles.cardSubtitle}>Resume Screening</p>

          {/* Candidate 1 */}
          <div className={styles.candidate}>
            <div className={styles.candidateInfo}>
              <div className={`${styles.avatar} ${styles.gray}`} />
              <div>
                <p className={styles.name}>Mr. Kaivalya</p>
                <p className={styles.role}>UX/UI designer &gt; 2 yrs</p>
              </div>
            </div>
            <input type="radio" disabled />
          </div>

          {/* Candidate 2 */}
          <div className={styles.candidate}>
            <div className={styles.candidateInfo}>
              <div className={`${styles.avatar} ${styles.purple}`} />
              <div>
                <p className={styles.name}>Ms. Naina</p>
                <p className={styles.role}>UX/UI designer &gt; 2 yrs</p>
              </div>
            </div>
            <div className={styles.check}>✓</div>
          </div>
        </div>
      </div>
    </div>
  );
}
